<template>
  <article class="media">
    <div class="media-content">
      <div class="content">
        <div class="mensagem-cabecalho">
          <div class="mensagem-cabecalho-esquerda">
            <div class="mensagem-cabecalho-meta">
              <template v-if="$slots.rotulo">
                <slot name="rotulo"></slot>
              </template>
              <template v-else-if="rotuloRemetente">
                <span class="rotulo-remetente">{{ rotuloRemetente }}</span>
              </template>
              <template v-if="nomeAposEmail">
                <small v-if="email" class="mr-2">{{ email }}</small>
                <strong v-if="nome" class="mr-2">{{ nome }}</strong>
                <small v-if="editadaEm" class="mensagem-editada"
                  >Editada em {{ editadaEm | formatarData }}</small
                >
              </template>
              <template v-else>
                <strong v-if="nome" class="mr-2">{{ nome }}</strong>
                <small v-if="email" class="mr-2">{{ email }}</small>
                <small v-if="editadaEm" class="mensagem-editada"
                  >Editada em {{ editadaEm | formatarData }}</small
                >
              </template>
            </div>
            <div class="mensagem-prefixo">
              <slot name="prefix"></slot>
            </div>
          </div>
          <div class="mensagem-cabecalho-direita">
            <small class="mensagem-data">{{ data | formatarData }}</small>
            <div class="mensagem-acoes">
              <slot name="acoes"></slot>
            </div>
          </div>
        </div>
        <slot></slot>
      </div>
      <slot name="respostas"></slot>
    </div>
  </article>
</template>

<script>
import { formatarData } from '@/utils/format';

export default {
  name: 'AppMensagem',
  props: {
    nome: String,
    email: String,
    data: {
      type: Date,
      default() {
        return new Date();
      },
    },
    rotuloRemetente: {
      type: String,
      default: '',
    },
    nomeAposEmail: {
      type: Boolean,
      default: false,
    },
    editadaEm: {
      type: Date,
      default: null,
    },
  },
  filters: {
    formatarData,
  },
};
</script>

<style scoped>
.media-content {
  overflow: unset !important;
}

.rotulo-remetente {
  font-weight: 600;
  margin-right: 0.35rem;
}

.mensagem-cabecalho {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  column-gap: 0.75rem;
  align-items: start;
  margin-bottom: 0.25rem;
}

.mensagem-cabecalho-esquerda {
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.mensagem-cabecalho-meta {
  line-height: 1.5;
}

.mensagem-editada {
  color: #7a7a7a;
  font-style: italic;
}

.mensagem-prefixo:empty {
  display: none;
}

.mensagem-prefixo ::v-deep .manifestacao-anexos {
  margin: 0;
}

.mensagem-cabecalho-direita {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-self: end;
  gap: 0.25rem;
}

.mensagem-data {
  display: block;
  white-space: nowrap;
  line-height: 1.5;
}

.mensagem-acoes {
  display: inline-flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: flex-end;
  gap: 0.35rem;
}

.mensagem-acoes:empty {
  display: none;
}

.mensagem-acoes ::v-deep .recurso-acoes {
  display: inline-flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  margin-bottom: 0;
  gap: 0;
}

.mensagem-acoes ::v-deep .button {
  margin: 0 !important;
}
</style>
